import * as stripe from './stripe-main.js';

export default {
    stripe,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Stripe
    window.EQLAPP.STRIPE = window.EQLAPP.STRIPE || {};
    Object.entries(stripe).forEach(([key, value]) => {
        window.EQLAPP.STRIPE[key] = value;
    });

}